import { render } from "./ReserveStepClients.vue?vue&type=template&id=04526877&scoped=true"
import script from "./ReserveStepClients.vue?vue&type=script&lang=js"
export * from "./ReserveStepClients.vue?vue&type=script&lang=js"

import "./ReserveStepClients.vue?vue&type=style&index=0&id=04526877&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04526877"]])

export default __exports__